import script from "./BsPlaceholder.vue?vue&type=script&lang=ts&setup=true"
export * from "./BsPlaceholder.vue?vue&type=script&lang=ts&setup=true"

import "./BsPlaceholder.vue?vue&type=style&index=0&id=64399a1f&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64399a1f"]])

export default __exports__